import { useQuery } from '@tanstack/react-query';

import { MonitoringApi } from 'api';
import { ACCOUNT_MONITORING_CONFIGS_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useAccountMonitoringConfigs() {
  const monitoringApi = new MonitoringApi();
  const { userBankId } = useUser();

  const { data: accountMonitoringConfigs = [], isLoading: isLoadingAccountMonitoringConfigs } = useQuery({
    enabled: !!userBankId,
    queryKey: [ACCOUNT_MONITORING_CONFIGS_KEY, userBankId],
    queryFn: () => monitoringApi.getAccountMonitoringConfigs()
  });

  return { accountMonitoringConfigs, isLoadingAccountMonitoringConfigs };
}
